import { useUploadRefreshWarning } from "../../hooks/useUploadRefreshWarning";

const UploadRefreshWarning = () => {
    useUploadRefreshWarning();
    return null;
};

export default UploadRefreshWarning;
